import React, { useState, useEffect } from "react";
import Card from "olive-react-myoneui/lib/Card";
import Tab from "olive-react-myoneui/lib/Tab";
import Nav from "olive-react-myoneui/lib/Nav";
import ApprenticeshipCarousel from "./CompletedApprenticeshipCarousel";
import MyCoursesCarousel from "./CompletedCoursesCarousel";
import { fetchProgramsPublicView } from "../../../api/programs";
import { checkDisabledSp } from "../../../helpers/permission_helper";

function CoursesApprenticeshipTabs({ setHasError, public_id, products, spUserAccessMap }) {
  const mykademyEnabled   = checkDisabledSp('mykademy', products, spUserAccessMap);
  const eportfolioEnabled = checkDisabledSp('eportfolio', products, spUserAccessMap);
  if(mykademyEnabled && eportfolioEnabled) {
    return (
      <></>
    );
  }

  return (
    <Card className="course-tabs-carousel myk__completed_course-tabs-carousel border-0 mb-0">
      <Card.Body className="p-0 pb-0">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey={!mykademyEnabled ? 'enrolledcourses' : 'apprenticeship'}
        >
          <div className="myk__courses-tabs_actions-wrapper d-flex gap-2 justify-content-between">
            <Nav variant="pills" className="p-0">
              { 
                !mykademyEnabled &&
                <Nav.Item>
                  <Nav.Link eventKey="enrolledcourses">
                    Completed Courses
                  </Nav.Link>
                </Nav.Item>
              }
              {!eportfolioEnabled && (
                <Nav.Item>
                  <Nav.Link eventKey="apprenticeship">
                    Completed Apprenticeship
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </div>
          <Tab.Content>
            { 
              !mykademyEnabled &&
              <Tab.Pane
                eventKey="enrolledcourses"
                className="bg-transparent ps-0 pb-3"
              >
                <MyCoursesCarousel publicId={public_id} setHasError={setHasError} mykademyEnabled={mykademyEnabled} />
              </Tab.Pane>
            }
            {!eportfolioEnabled && (
            <Tab.Pane
              eventKey="apprenticeship"
              className="bg-transparent ps-0 pb-3"
            >
              <ApprenticeshipCarousel publicId={public_id} setHasError={setHasError} />
            </Tab.Pane>)}
          </Tab.Content>
        </Tab.Container>
      </Card.Body>
    </Card>
  );
}

export default CoursesApprenticeshipTabs;
